import React, { useEffect, useRef } from "react";

const PreReleaseModal = ({ isOpen, onClose, children, title }) => {
    const modalRef = useRef(null);

    // Trap focus inside modal
    useEffect(() => {
        if (!isOpen) return;
        const focusable = modalRef.current?.querySelectorAll(
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        if (focusable && focusable.length) focusable[0].focus();
        const handleKeyDown = (e) => {
            if (e.key === "Escape") onClose();
            if (e.key === "Tab" && focusable && focusable.length) {
                const first = focusable[0];
                const last = focusable[focusable.length - 1];
                if (e.shiftKey ? document.activeElement === first : document.activeElement === last) {
                    e.preventDefault();
                    (e.shiftKey ? last : first).focus();
                }
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    // Close on overlay click
    const handleOverlay = (e) => {
        if (e.target === e.currentTarget) onClose();
    };

    if (!isOpen) return null;
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 transition-opacity duration-200"
            onClick={handleOverlay}
            aria-modal="true"
            role="dialog"
            tabIndex={-1}
        >
            <div
                ref={modalRef}
                className="bg-white rounded-lg shadow-2xl max-w-lg w-full p-6 relative animate-fadeIn overflow-y-auto max-h-[90vh]"
                style={{ minWidth: 320 }}
            >
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold focus:outline-none"
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    &times;
                </button>
                {title && <h2 className="text-lg font-bold mb-4 text-center">{title}</h2>}
                {children}
            </div>
        </div>
    );
};

export default PreReleaseModal;
